import React from 'react';
import styles from './index.module.scss';

interface Props {
  title?: any;
  subTitle?: string;
  children?: React.ReactNode;
}

export default ({ title = '', subTitle = '', children }: Props) => {
  return (
    <div className={styles['big-box']}>
      <div className={styles['top-box']}>
        <div className={styles['blue-box']}/>
        <div className={styles['title-box']}>
          {title}
          <span className={styles['sub-title']}>{subTitle}</span>
        </div>
      </div>
      {children}
    </div>
  );
};
